import { RootState } from '../store';

export const CashierSelector = (state: RootState) => state.cashier;
